module.exports = __webpack_public_path__ + "assets/img/urlTrue.2b0f64d9.svg";